module.exports = __webpack_public_path__ + "img/bg4.c3d7e006.png";